import React from 'react';

import Text from '@skippay/core/components/Text';
import { FormattedMessage } from '@skippay/core/i18n/intl';

function Copyright(): JSX.Element {
	const currentYear = new Date().getFullYear();
	return (
		<Text align="center" size="paragraphSmall" color="light-gray-500">
			<FormattedMessage
				defaultMessage="© {currentYear} Skip Pay s. r. o."
				id="Copyright.company"
				values={{
					currentYear,
				}}
			/>
		</Text>
	);
}

export default Copyright;
